var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsCrossSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "standard/action/cross-small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.778157,2.22942738 C11.4823663,1.93363671 11.0045506,1.93363671 10.70876,2.22942738 L7,5.93060296 L3.29124005,2.221843 C2.99544937,1.92605233 2.51763367,1.92605233 2.221843,2.221843 C1.92605233,2.51763367 1.92605233,2.99544937 2.221843,3.29124005 L5.93060296,7 L2.221843,10.70876 C1.92605233,11.0045506 1.92605233,11.4823663 2.221843,11.778157 C2.51763367,12.0739477 2.99544937,12.0739477 3.29124005,11.778157 L7,8.06939704 L10.70876,11.778157 C11.0045506,12.0739477 11.4823663,12.0739477 11.778157,11.778157 C12.0739477,11.4823663 12.0739477,11.0045506 11.778157,10.70876 L8.06939704,7 L11.778157,3.29124005 C12.0663633,3.00303375 12.0663633,2.51763367 11.778157,2.22942738 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "standard/action/cross-small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrossSmall);
export default __webpack_public_path__ + "static/media/icons_cross_small.376fe903e59a1f9664e6a11e5c1eab72.svg";
export { ForwardRef as ReactComponent };